import { useTranslation } from 'react-i18next';

interface FooterProps {
  onContact: () => void;
}

export default function Footer({ onContact }: FooterProps) {
  const { t } = useTranslation();

  return (
    <footer id="empresa" className="bg-[#03912c] text-white py-8 sm:py-16">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-12 mb-6 sm:mb-12">
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://static.readdy.ai/image/d4364c93ef6f707650170405d0b37024/20667ea90eb4947e1e8636b4d4e845c0.png"
              alt="PPP Exports"
              className="h-10 sm:h-16 w-auto mb-2 sm:mb-4 brightness-0 invert"
            />
            <p className="text-white/70 text-[0.7rem] sm:text-sm mb-3 sm:mb-6">
              {t('footer.tagline')}
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <div
                className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 rounded-full opacity-40 cursor-default"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-base sm:text-xl" aria-hidden="true"></i>
              </div>
              <div
                className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 rounded-full opacity-40 cursor-default"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-fill text-base sm:text-xl" aria-hidden="true"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-xs sm:text-lg font-bold mb-2 sm:mb-4">{t('footer.productos')}</h4>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <a
                  href="#productos"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.productPalmito')}
                </a>
              </li>
              <li>
                <a
                  href="#productos"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.productPina')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs sm:text-lg font-bold mb-2 sm:mb-4">{t('footer.empresa')}</h4>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <a
                  href="#por-que-elegirnos"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.porQueElegirnos')}
                </a>
              </li>
              <li>
                <a
                  href="#capacidades"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.capacidades')}
                </a>
              </li>
              <li>
                <a
                  href="#costa-rica"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.porQueCR')}
                </a>
              </li>
              <li>
                <a
                  href="#proceso"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.proceso')}
                </a>
              </li>
              <li>
                <a
                  href="#productos"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.productosLink')}
                </a>
              </li>
              <li>
                <a
                  href="#soluciones"
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.soluciones')}
                </a>
              </li>
              <li>
                <button
                  onClick={onContact}
                  className="text-white/70 hover:text-white transition-colors text-[0.7rem] sm:text-sm cursor-pointer"
                >
                  {t('footer.contactoLink')}
                </button>
              </li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h4 className="text-xs sm:text-lg font-bold mb-2 sm:mb-4">{t('footer.contacto')}</h4>
            <ul className="space-y-1.5 sm:space-y-3 text-[0.7rem] sm:text-sm text-white/70">
              <li className="flex items-start">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 mt-0.5">
                  <i className="ri-mail-line" aria-hidden="true"></i>
                </div>
                <a href="mailto:pppexportcostarica@gmail.com" className="hover:text-white cursor-pointer break-all">
                  pppexportcostarica@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 mt-0.5">
                  <i className="ri-map-pin-line" aria-hidden="true"></i>
                </div>
                <span>San José, Costa Rica</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-4 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-2 text-[0.65rem] sm:text-sm text-white/60">
          <p>{t('footer.derechos')}</p>
          <a
            href="https://www.unionlab.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer"
          >
            Powered by Union Lab
          </a>
        </div>
      </div>
    </footer>
  );
}
